// extracted by mini-css-extract-plugin
export var expand = "ParagraphImages-module--expand--9275c";
export var pagination = "ParagraphImages-module--pagination--05a01";
export var paragraphimagesinner = "ParagraphImages-module--paragraphimagesinner--401f3";
export var swiper = "ParagraphImages-module--swiper--8a23d";